// extracted by mini-css-extract-plugin
module.exports = {"title":"SettungsInbox_title__3P9Da","alert":"SettungsInbox_alert__3KCrw"};